import React, { useContext, useMemo } from 'react';
import { ICreateVideoContext, CreateVideoContext } from '../../createVideoState/createVideoContext';
import PageBookmarkBtn from 'components/PageBookmarkBtn/PageBookmarkBtn';
import style from './CreateVideoControlPanel.module.scss';

const CreateVideoControlPanel: React.FC = () => {
	const { changeVisibleForm, IDsSelectedLanguages, visibleForm, translations } =
		useContext<ICreateVideoContext>(CreateVideoContext);

	const hasTranslationError = useMemo(() => {
		if (!IDsSelectedLanguages.length) {
			return false;
		}
		const someTranslationIsEmpty = translations.some((translation) => translation.name === '');
		return someTranslationIsEmpty;
	}, [IDsSelectedLanguages, translations]);

	return (
		<div className={style.container} data-test="CreateVideoControlPanel">
			<PageBookmarkBtn
				onClick={() => changeVisibleForm('mainForm')}
				isActive={visibleForm === 'mainForm'}
				btnName="mainInfoBookmark"
			/>
			<PageBookmarkBtn
				onClick={() => changeVisibleForm('translations')}
				isActive={visibleForm === 'translations'}
				btnName="translationsBookmark"
				isError={hasTranslationError}
			/>
		</div>
	);
};

export default CreateVideoControlPanel;
